import {gettext, LANGUAGES} from './translationService';

export const LANGUAGE_OPTIONS = [
    {label: gettext('English'), value: LANGUAGES.en},
    {label: gettext('Spanish'), value: LANGUAGES.es}
];
